<footer class="main-footer">
  <div class="container-dynamic d-flex">
    <p class="mb-0">Licenciado a: <span class="text-secondary">{{licencaEmpresa}}</span></p>
    <span class="m-auto"></span>
    <p class="mb-0">
      Desenvolvido por &ensp;<a href="https://kiamisoft.co.ao" class="text-secondary"> KiamiSoft</a>
    </p>
  </div>
</footer>
